import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-in-process',
  templateUrl: './order-in-process.component.html',
  styleUrls: ['./order-in-process.component.less']
})
export class OrderInProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
